module.exports = __webpack_public_path__ + "static/media/wealthbox-logo-light.803ed482.png";